import { useStatsigLayer } from '@/hooks';
import { useMyParcelsContext } from '@/modules/pmt/context';

// The pop-up only opens right after a Google sign-in, so it is read from the signed-in layer only
export const useGrantAccessPopupCopy = () => {
  const { trackingTranslation } = useMyParcelsContext();
  const { getEnglishOnlyText, isReady } = useStatsigLayer('track_my_parcel_signed_in_layer');

  const { mainTextGrantAccessPopup, subTextGrantAccessPopup, mainButtonGrantAccessPopup } = trackingTranslation;

  const fallback = {
    mainText: mainTextGrantAccessPopup ?? '',
    subText: subTextGrantAccessPopup ?? '',
    cta: mainButtonGrantAccessPopup ?? '',
  };

  if (!isReady) return fallback;

  return {
    mainText: getEnglishOnlyText('grant_access_main_text', fallback.mainText),
    subText: getEnglishOnlyText('grant_access_subtext', fallback.subText),
    cta: getEnglishOnlyText('grant_access_cta', fallback.cta),
  };
};
